const actions = {
  SET_STATE: 'payment/SET_STATE',
  INIT_PAYMENT: 'payment/INIT_PAYMENT',
  STORE_CREDS: 'payment/STORE_CREDS',
  VERIFY_HASH: 'payment/VERIFY_HASH',
  UPDATE_TRANSACTION: 'payment/UPDATE_TRANSACTION'
}

export default actions
